import {Component, OnDestroy, OnInit} from '@angular/core';
import {UntypedFormBuilder, FormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {Select, Store} from "@ngxs/store";
import {AuthState, AuthStateModel} from "../../states/auth.state";
import {Observable, Subscription} from "rxjs";
import {Navigate} from "@ngxs/router-plugin";
import {LoginAction} from "../../actions/auth.actions";
import {ActivatedRoute} from "@angular/router";
import {RecoverPasswordAction} from "../../actions/account.actions";
import {AccountState, AccountStateModel} from "../../states/account.state";

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {

  loginForm: UntypedFormGroup

  private returnUrl: any;

  @Select(AccountState.getRecoverPasswordStatus) accountState$: Observable<AccountStateModel>;
  private auth$Sub: Subscription;
  resetError: boolean = false;
  resetErrorMessage: string = '';
  resetSuccess: boolean = false;
  submitted: boolean = false;

  constructor(
    private _builder:UntypedFormBuilder,
    private store: Store,
    private route: ActivatedRoute
  ) {
    this.loginForm = this._builder.group({
      email: ['', [Validators.required, Validators.email]]
    })


  }

  enviar(values) {
    this.submitted = true;
    this.resetError = false;
    this.resetSuccess = false;
    if(this.loginForm.valid) {
      this.resetError = false;
      this.resetErrorMessage = null;
      this.store.dispatch(new RecoverPasswordAction({email: values.email}))
    } else {
      this.resetError = true;
      this.resetErrorMessage = "El email ingresado no es válido";
    }

  }

  ngOnInit(): void {
    this.submitted = false;
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || 'dashboard';
    this.resetSuccess = false;
    this.resetError = false;

    this.auth$Sub = this.accountState$.subscribe(authData => {
      if(authData.recoverPasswordError) {
        this.resetSuccess = false;
        this.resetError = true;
        this.resetErrorMessage = authData.recoverPasswordErrorMessage;
      } else {
        this.resetErrorMessage = null;
        this.resetSuccess = true;
        this.resetError = false;
        this.loginForm.patchValue({email:''})
      }
    });
  }

  ngOnDestroy() {
    if(this.auth$Sub) {
      this.auth$Sub.unsubscribe();
    }
  }

}
